"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
/**
 * Declarative approach to setInterval, stolen from Dan Abramov.
 * https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 *
 *  @param {function} callback
 *  @param {number} delay
 *
 *  @example
 *  useInterval(() => {
 *    if (props.bets.fetchStatus !== "fetchingData") {
 *      props.loadData();
 *    }
 *  }, 10000)
 *
 *
 */
exports.useInterval = function (callback, delay) {
    var savedCallback = react_1.useRef(null);
    react_1.useEffect(function () {
        savedCallback.current = callback;
    }, [callback]);
    // use setInterval within a useEffect block, so it is called appropriately by React.
    react_1.useEffect(function () {
        var tick = function () {
            if (savedCallback.current)
                savedCallback.current();
        };
        if (delay !== null) {
            var id_1 = setInterval(tick, delay);
            return function () { return clearInterval(id_1); };
        }
    }, [delay]);
};
